import { formatDate, formatNumber, formatPrice, getAvatarInitial, getCurrencySymbol, limitText, mimeToFileName } from "@/helpers";

const mixin = {
    data() {
        return {
            currencySymbol: getCurrencySymbol(),
        };
    },

    methods: {
        getAvatarInitial: fullName => getAvatarInitial(fullName),
        
        getCurrencySymbol: () => getCurrencySymbol(),

        formatPrice: (price, symbol) => formatPrice(price, symbol),

        formatNumber: number => formatNumber(number),

        transformDate: date => formatDate(date),

        limitText: (text, limit) => limitText(text, limit),

        mimeToFileName: mime => mimeToFileName(mime),

        // isAdmin: () => {
        //     const data = isAdmin();
        //     console.log('calling from mixin', data);
        //     return data;
        // },
    }
};

export default mixin;